import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { User } from '../models/user';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/catch';

@Injectable()
export class UserService {

  constructor(private _http: Http) {
    
   }

   GetUser(): Observable<User> {    
    return this._http.get('/api/values/3')
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let data
    if (res.text()) {
      data = res.json();
    }
    return data || {};
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts